import EfImg from '@elem/ui/ef-img';
import { useGlobal } from '@/utils/useGlobal';

export default function Step({ user }: any) {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('supportcasecreate');
    if (!user) {
        return <></>;
    }
    const emailPrefix = user.email?.split('@')[0] || '--';

    return (
        <div className="user-content">
            <div className="user-info">
                <EfImg className="avatar" pc={user.icon} />
                <div className="text">
                    <p className="username">{user.name || emailPrefix}</p>
                    <p className="email">{user.email}</p>
                </div>
            </div>
            <p className="desc">{t('desc')}</p>
        </div>
    );
}
